import { jsonGet } from "../api";

/**
 * Everything the traffic dashboard draws, aggregated server-side.
 *
 * Replaces pulling up to 1,000 raw events into the browser and reducing them here. That capped
 * every chart at the newest 1,000 events — so the wider the window, the more it under-reported —
 * and bucketed in the viewer's local timezone, which made the same brand's busiest hour depend on
 * who was looking at it.
 *
 * The paged /traffic endpoint still exists on the server for callers that want individual events;
 * nothing in this UI does any more.
 */
export const fetchTrafficSummary = async (projectId, { days = 30, granularity = "day" } = {}) => {
  if (!projectId) throw new Error("projectId is required");
  return await jsonGet(`traffic/${projectId}/summary?days=${days}&granularity=${granularity}`);
};
